import fetch from '@/utils/fetch'

export const List = '/subsidy/taskCodes'

// 新建国补活动
export function createActivityCodes (data) {
  return fetch({
    url: '/subsidy/taskCodes',
    method: 'post',
    data
  })
}
//修改国补活动
export function updateActivityCodes (data) {
  return fetch({
    url: '/subsidy/taskCodes',
    method: 'put',
    data
  })
}

// 删除国补活动
export function deleteActivityCodes (params) {
  return fetch({
    url: `/subsidy/taskCodes/` + params,
    method: 'delete'
  })
}

// 国补活动添加商品
export function setActivityItems (data) {
  return fetch({
    url: '/subsidy/taskItems',
    method: 'post',
    data
  })
}

// 删除活动关联的商品
export function deleteActivityItems (params) {
  return fetch({
    url: `/subsidy/taskItems`,
    method: 'delete',
    params
  })
}